import { client } from '../sanity'

export interface BrandListItem {
  _id: string
  name: string
}

/**
 * Fetch all Sanity brands for selection.
 */
export const getBrands = async (): Promise<BrandListItem[]> => {
  return client.fetch(
    `*[_type == "brand"] | order(name asc) {
      _id,
      name
    }`
  )
}

